import { PedidoHistorialApi } from '../models/api/pedido-api';

export class EstadoPedidoUtility {
    private static readonly nombresCliente: Record<string, string> = {
        RESERVADO: 'Reservado',
        PAGO_POR_VERIFICAR: 'Pago en verificación',
        PAGO_RECHAZADO: 'Pago rechazado',
        PAGO_CONFIRMADO: 'Pago confirmado',
        VENTA_ERROR: 'Pago confirmado',
        EN_PREPARACION: 'En preparación',
        LISTO: 'Listo para entrega',
        EN_CAMINO: 'En camino',
        ENTREGADO: 'Entregado',
        NO_ENTREGADO: 'No entregado',
        CANCELADO: 'Cancelado'
    };

    private static readonly internos = ['RESERVADO', 'VENTA_ERROR'];

    static nombreCliente(codigo: string | null | undefined, alterno?: string | null): string {
        if (!codigo) {
            return alterno ?? '';
        }
        return EstadoPedidoUtility.nombresCliente[codigo] ?? alterno ?? codigo;
    }

    static historialCliente(historial: PedidoHistorialApi[] | null | undefined): PedidoHistorialApi[] {
        return (historial ?? [])
            .filter((h) => !EstadoPedidoUtility.internos.includes(h.estadoCodigo))
            .map((h) => ({ ...h, estado: EstadoPedidoUtility.nombreCliente(h.estadoCodigo, h.estado) }));
    }
}
